export default "__VITE_ASSET__HCok0R1E__"